import React, { useEffect, useState } from 'react';
import AdvisorSection from '../advisors_section';
import { advisorsSectionThemes } from '../../prop_types';
import classes from './classes.module.scss';

function PersonalSection({
  personalSections = {},
  index = 0
}) {
  const [selectedSection, setSelectedSection] = useState(
    (personalSections[Object.keys(personalSections)[0]] || {}).id
  );
  useEffect(() => {
    if (!!personalSections && (!selectedSection || selectedSection === undefined)) {
      setSelectedSection(
        (personalSections[Object.keys(personalSections)[0]] || {}).id
      );
    }
  }, [personalSections]);

  const personalSectionsMenuItemClick = (e) => {
    setSelectedSection(e.target.id);
  };

  const renderPersonalSection = () => (
    <div className={ classes.personalSectionsContainer } data-testid="HP-personal-section">
      <div className={ classes.personalSectionsMenuContainer }>
        <div className={ classes.personalSectionsMenuItemsContainer }>
          { Object.keys(personalSections).map((key) => (
            <div
              key={ personalSections[key].id }
              className={ classes.personalSectionsMenuItemContainer }
            >
              <button
                id={ personalSections[key].id }
                type="button"
                className={
                  selectedSection === personalSections[key].id
                    ? classes.personalSectionsMenuItemSelected
                    : classes.personalSectionsMenuItem
                }
                onClick={ personalSectionsMenuItemClick }
              >
                { personalSections[key].title }
              </button>
              <div className={ classes.smallDivider } />
            </div>
          )) }
        </div>
        <div className={ classes.divider } />
      </div>
      <div className={ classes.personalSectionsAdvosorsContainer }>
        <AdvisorSection
          { ...personalSections[selectedSection] }
          theme={ advisorsSectionThemes.personal }
          personalSection
          sectionIndex={ index + Object.keys(personalSections).findIndex(x => x === selectedSection) }
        />
      </div>
    </div>
  );

  return (
    <>
      { renderPersonalSection() }
    </>
  );
}

export default PersonalSection;
